import { FunctionComponent as F } from "react";
import { useAppDispatch } from "../../core/store/hooks";
import { useSelector } from 'react-redux';
import { IState } from "../../core/store/store";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography';
import Button from '../UI/Button/Button';
import { deleteProtocolAsync, duplicateAsync } from "../../core/store/protocol/protocol.thunks";
import { useNavigate, useParams } from "react-router-dom";
import { PROTOCOL } from "../../core/router/paths";
import { Box } from "@mui/material";



interface IParams
{
  protocolId?: string
}


interface IProps
{
  protocolId: number,
  close: () => void,
  open: boolean
}

const DuplicateProtocolWarningDialog: F<IProps> = (props: IProps) =>
{
  const navigate = useNavigate();
  const appDispatch = useAppDispatch();
  const params = useParams() as IParams;
  const displayedProtocolId = Number(params.protocolId);

  const userId = useSelector((state: IState) => state.user.userId);
  const userProtocol = useSelector((state: IState) => state.protocol.protocols.find(p => p.userId === userId));
  if(!userProtocol)
    return <></>;

  const handleConfirm = async() =>
  {
    props.close();
    const protocolId = await appDispatch(duplicateAsync(props.protocolId));

    // Navigate away before deleting free user's protocol
    if(userProtocol.protocolId === displayedProtocolId)
      navigate(PROTOCOL + "/" + props.protocolId);

    await appDispatch(deleteProtocolAsync(userProtocol.protocolId));

    // Navigate back to duplicate protocol
    navigate(PROTOCOL + "/" + protocolId);
  }

  return (
    <Dialog
      maxWidth='md'
      PaperProps={{ sx: { p: '15px', textAlign: 'center' }}}
      open={props.open}
      onClose={props.close}>
      <DialogTitle sx={{ fontSize: '30px' }}>{"Warning"}</DialogTitle>
      <DialogContent>
        <Typography variant='body2'>
          {"This will replace your current protocol, \"" + userProtocol.name + "\". "}
          <br/>
          {"Proceed?"}
        </Typography>
        <Box height='35px'/>
        <Button
          label='Cancel'
          onClick={props.close}/>
        <Button
          label='Ok'
          onClick={handleConfirm}/>
      </DialogContent>
    </Dialog>);
}

export default DuplicateProtocolWarningDialog;

